import { SegmentedControl, Separator, StaticMenuLayout, VText } from '@vake/ui-kit';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Filters, Props as FiltersProps } from './filters';

type Props = {
    reportName: string;
    selected: number;
    setSelected: (value: number) => void;
    filtersProps: FiltersProps;
};
export const LeftBar: FC<Props> = ({ reportName, selected, setSelected, filtersProps }) => {
    const Menu = () => {
        return (
            <div className="flex flex-col gap-2">
                <Link to={'/'}>
                    <VText variant="B2">Go to home</VText>
                </Link>
                <Separator opaque />
                <Link to={'/overwatch-reports'}>
                    <VText variant="B2">Go to all reports</VText>
                </Link>
            </div>
        );
    };
    const TheRest = () => {
        return (
            <div className="flex flex-col">
                <SegmentedControl selected={selected} setSelected={setSelected}>
                    <SegmentedControl.Item label="Filters">
                        <Filters {...filtersProps} />
                    </SegmentedControl.Item>
                    <SegmentedControl.Item label="Settings">
                        <div className="p-4">
                            <VText>Coming soon</VText>
                            {/* <Button
                                size="small"
                                variant="neutral"
                                iconBefore={<Download size={16} />}
                                text="Download full dataset as CSV"
                                onClick={() => {}}
                            /> */}
                        </div>
                    </SegmentedControl.Item>
                </SegmentedControl>
            </div>
        );
    };
    return <StaticMenuLayout title={reportName} menuChildren={<Menu />} children={<TheRest />} />;
};
